import { FC, ReactElement, useRef } from 'react';

import { Icon } from '@pp/core/src/components/icons/icon';
import { Icons } from '@pp/core/src/components/icons/iconNames';
import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import { RecentResultsItemType } from '../../../api/recentResults';
import { useGameDispatch } from '../../../store/GameStore';
import { useHighflyerGameStateSlice } from '../../../store/slices/highflyerGame/selectors';
import { useRecentResultDetailStateSlice } from '../../../store/slices/recentResultDetail/selectors';
import { recentResultDetailStateActions } from '../../../store/slices/recentResultDetail/slice';
import { Copied } from '../copied/Copied';

import { CopyToClipboard } from './CopyToClipboard';

import styles from './ValueContainer.module.css';

export interface ModalHashProp {
  index: number;
}

export const ModalHash: FC<ModalHashProp> = ({ index }): ReactElement => {
  const hash = useRef<string>('');
  const dispatch = useGameDispatch();
  const audioTrigger = useAudioTrigger();
  const copied = useRecentResultDetailStateSlice.getCopied();
  const hashResult = useRecentResultDetailStateSlice.getHashResult();
  const clickedTab = useRecentResultDetailStateSlice.getHashModalData().clickedTab;
  const totalResults: number = useHighflyerGameStateSlice.recentResultsCount();

  let details: RecentResultsItemType | undefined;

  if (clickedTab !== 'footer') {
    hash.current = hashResult;
  } else if (index >= 0 && clickedTab === 'footer') {
    if (index < totalResults) {
      details = useHighflyerGameStateSlice.recentResults()?.history[index];
    }
    if (details) {
      hash.current = details.gameEncryptedResult;
    }
  } else {
    hash.current = useRecentResultDetailStateSlice.getInPlayHash();
  }

  const copyToClipboard = (content: string) => {
    audioTrigger.play({ name: 'menuClick' });
    dispatch(recentResultDetailStateActions.setCopied(1));
    setTimeout(() => {
      dispatch(recentResultDetailStateActions.setCopied(0));
    }, 1500);
    CopyToClipboard(content);
  };

  return (
    <div className={styles.modalHash}>
      <div className={styles.modalValueName}>
        <L10nText tk={'HASH'} />:{copied === 1 && <Copied />}
      </div>
      <div className={styles.modalValueContainer}>
        <div className={styles.modalValueLeft}>{hash.current}</div>
        <div className={styles.modalValueCopy} onClick={() => copyToClipboard(hash.current)} id="modal-hash">
          <button>
            <Icon icon={Icons.Copy} color="white" />
          </button>
        </div>
      </div>
    </div>
  );
};
